/**
 * @fileoverview POST handler for the "/alloys/:partner/cohort_import/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAlloysPartnerCohortImportAppGroupIdCacheKeys } from "./constants";
import type {
  PostAlloysPartnerCohortImportAppGroupIdProps,
  PostAlloysPartnerCohortImportAppGroupIdResult,
} from "./types";

export const postAlloysPartnerCohortImportAppGroupId = reactQueryMutationAdapter(
  postAlloysPartnerCohortImportAppGroupIdCacheKeys,
  (props: PostAlloysPartnerCohortImportAppGroupIdProps): Promise<PostAlloysPartnerCohortImportAppGroupIdResult> => {
    return fetch(`/alloys/${props.partner}/cohort_import/${props.appGroupId}`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
